import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { AppRole, ROLE } from '../constants/roles';

export const isRLAdminViewRole = (
    role: AppRole | null | undefined
): boolean => {
    if (!role) {
        return false;
    }
    const name = role.roleName?.trim().toLowerCase();
    return (
        role.id === ROLE.RL_ADMIN_VIEW.id ||
        name === ROLE.RL_ADMIN_VIEW.roleName.toLowerCase()
    );
};

export const hasRLAdminViewRole = (
    roles: AppRole | AppRole[] | null | undefined
): boolean => {
    if (!roles) {
        return false;
    }
    const roleList = Array.isArray(roles) ? roles : [roles];
    return roleList.some(isRLAdminViewRole);
};

/** RL Admin View must be assigned alone — it cannot be mixed with other roles. */
export const isRLAdminViewCombinedWithOtherRoles = (
    roles: AppRole | AppRole[] | null | undefined
): boolean => {
    if (!roles) {
        return false;
    }
    const roleList = Array.isArray(roles) ? roles : [roles];
    return roleList.length > 1 && hasRLAdminViewRole(roleList);
};

/**
 * Read-only access for users with role "RL Admin View" (id: 5)
 * on the currently selected company.
 */
export const useRLAdminView = () => {
    const companyDetails: any = useSelector(
        (state: RootState) => state.sideBarReducer.companyDetails
    );

    const isRLAdminView = hasRLAdminViewRole(companyDetails?.roles);

    return {
        isRLAdminView,
        isReadOnly: isRLAdminView,
        canAdd: !isRLAdminView,
        canEdit: !isRLAdminView,
        canDelete: !isRLAdminView,
        canSave: !isRLAdminView,
    };
};

export default useRLAdminView;
